import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "page-title" }, "Création de propriété personnalisée", -1)
const _hoisted_2 = { class: "form-container" }

import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import router from "@/router";
import {ref} from "vue";
import CustomButton from "@/components/forms/CustomButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomPropertiesCreate',
  setup(__props) {

const  specialProperties = ref();
function checkDuplicateName(node){
  return specialProperties.value.filter((property) => property.value.toLowerCase() === node.value.toLowerCase()).length === 1
}
function submitHandler(data, formNode) {
  return ApiService.post("/properties", data)
    .then(({data}) => {
      swal.success("Propriété créée !", "");
      router.push({ name: 'customPropertiesList' });
    })
    .catch(({response}) => {
      response.data.errors.forEach((error) => {
        let field = error.property;
        if (field) {
          field = field.replace('[', '.');
          field = field.replace(']', '');
          formNode.setErrors(
            null,
            {
              [field]: error.message
            }
          );
        }
        return false;
      });
    });
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomButton, {
      to: { name: 'customPropertiesList' },
      label: "Links.goBack"
    }),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FormKit, {
        type: "form",
        onSubmit: submitHandler,
        actions: false,
        "incomplete-message": "Désolé, tous les champs ne sont pas remplis correctement."
      }, {
        default: _withCtx(() => [
          _createVNode(_component_FormKit, {
            type: "text",
            name: "name",
            label: "Propriété",
            placeholder: "Entrer un nom de propriété",
            validation: "required|length:1,50",
            "validation-messages": {
                required: 'Ce champ est obligatoire.',
                length: 'Ce champ doit contenir maximum 50 caractères.',
                }
          }, null, 8, ["validation-messages"]),
          _createVNode(_component_FormKit, {
            id: "repeater",
            modelValue: specialProperties.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((specialProperties).value = $event)),
            name: "values",
            type: "repeater",
            label: "Valeurs de la propriété",
            "add-label": "Ajouter une valeur",
            min: "1"
          }, {
            default: _withCtx(({ index }) => [
              _createVNode(_component_FormKit, {
                type: "text",
                label: `${index + 1}. Valeur`,
                name: "value",
                validation: "required|length:1,50|checkDuplicateName",
                "validation-rules": {checkDuplicateName: checkDuplicateName},
                placeholder: "Entrer une valeur",
                "validation-messages": {
                required: 'Ce champ est obligatoire.',
                length: 'Ce champ doit contenir maximum 50 caractères.',
                checkDuplicateName:'Cette valeur existe déjà.'
                }
              }, null, 8, ["label", "validation-rules", "validation-messages"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_FormKit, {
            type: "submit",
            label: "Céer"
          })
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})